import { Navigate } from "react-router-dom";
import { AuthLayout } from "../pages/auth/layout/AuthLayout";
import { Login } from "../pages/auth/Login";
import { ResetPassword } from "../pages/auth/ResetPassword";
import { RequestPasswordReset } from "../pages/auth/RequestPasswordReset";
import { IModuleRouter } from "./index";
import { EnterOtp } from "../pages/auth/EnterOtp";
import { ResetSuccess } from "../pages/auth/ResetSuccess";

export const AuthRouter: IModuleRouter = {
  key: "auth",
  guard: (loggedIn) => !loggedIn,
  // @ts-ignore
  layout: AuthLayout,
  routes: [
    // {
    //   index: true,
    //   element: <Navigate to="/login" />,
    // },
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/reset-password",
      element: <ResetPassword />,
    },
    {
      path: "/request-password-reset",
      element: <RequestPasswordReset />,
    },
    {
      path: "/enter-otp",
      element: <EnterOtp />,
    },
    {
      path: "/reset-success",
      element: <ResetSuccess />,
    }, 
    {
      path: "*",
      element: <Navigate to="/login" />,
    },
  ],
};
